import { ListItem, ListItemButton, ListItemIcon, styled } from '@mui/material'

///////////////////////////////////
// App Template Styles
///////////////////////////////////

export const drawerWidth = 256

export const AppTemplateContainer = styled('div')(() => ({
  display: 'flex',
  minHeight: '100vh',
}))

export const Drawer = styled('nav')(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: drawerWidth,
    flexShrink: 0,
  },
}))

export const App = styled('div')(() => ({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
}))

export const AppMain = styled('main')(({ theme }) => ({
  flex: 1,
  padding: theme.spacing(3, 2),
}))

export const Footer = styled('footer')(({ theme }) => ({
  padding: theme.spacing(1),
}))

///////////////////////////////////
// Navigation Styles
///////////////////////////////////

export const NavigatorItemCategory = styled(ListItem)(({ theme }) => ({
  backgroundColor: '#232f3e',
  boxShadow: '0 -1px 0 #404854 inset',
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
}))

export const NavigatorButton = styled(ListItemButton)(() => ({
  paddingTop: 1,
  paddingBottom: 1,
  color: 'rgba(255, 255, 255, 0.7)',
  '&:hover,&:focus': {
    backgroundColor: 'rgba(255, 255, 255, 0.08)',
  },
})) as typeof ListItemButton

export const NavigatorIcon = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 'auto',
  marginRight: theme.spacing(2),
}))
